import { isArray } from '@seiue/util'
import { QuestionnaireSubmitRes } from 'packages/sdks-next/growp'
import { AnyType, AnyValueObj } from 'packages/types'

/**
 * 格式化学生填写的问卷详情数据
 *
 * @param originData - 原始数据
 * @returns 键值对数组
 */
export const formatOriginData = (originData: QuestionnaireSubmitRes[]) => {
  return originData
    .map((origin) => origin.value)
    .reduce((acc, cur) => Object.assign(acc, cur), {})
}

/**
 * 获取学生填写的单选或多选中的其它数据
 *
 * @param originData - 原始数据
 * @returns otherInfo
 */
export const getInitOtherInfo = (originData: QuestionnaireSubmitRes[]) => {
  const otherInfo: AnyValueObj = {}
  originData.map((origin) => {
    if (isArray(origin.otherValue)) {
      origin.otherValue.map((v: AnyValueObj) => {
        Object.keys(v).map((k) => {
          otherInfo[k] = v[k]
        })
      })
    }
  })
  return otherInfo
}

/**
 *过滤掉数组中的空对象,若过滤后为空数组，则返回undefined

 * @param originValue
 * @returns
 */
export const compact = (originValue: AnyType) => {
  if (isArray(originValue)) {
    const finalValue = originValue.filter((i) => JSON.stringify(i) !== '{}')
    if (!finalValue.length) {
      return undefined
    }
  }
  return originValue
}
